import createStyledEnhancer from "../helpers/createStyledEnhancer";
import { composeEnhancers } from "../helpers";
export var positionProperty = createStyledEnhancer({
  name: "position"
});
export var top = createStyledEnhancer({
  name: "top"
});
export var right = createStyledEnhancer({
  name: "right"
});
export var bottom = createStyledEnhancer({
  name: "bottom"
});
export var left = createStyledEnhancer({
  name: "left"
});
export var position = composeEnhancers(positionProperty, top, right, bottom, left);